export default "__VITE_ASSET__0wFQrT0X__"